import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { StatusBadge } from "../components/StatusBadge";

function fmt(iso) { return iso ? new Date(iso).toLocaleString() : ""; }

export default function Incidents() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.listIncidents().then(setItems); }, []);
  return (
    <div className="space-y-6" data-testid="incidents-page">
      <header>
        <div className="text-[11px] tracking-eyebrow text-muted-foreground">Incidents &amp; reports</div>
        <h1 className="text-3xl sm:text-4xl tracking-tight font-medium mt-2">All submitted reports</h1>
        <p className="text-sm text-muted-foreground mt-2">Each report is classified by the AI assistant (advisory) and routed to a named human role for governance.</p>
      </header>
      {items.length === 0 && <Card className="p-6 text-sm text-muted-foreground">No incidents submitted yet. <Link to="/intake" className="underline">Submit one →</Link></Card>}
      <div className="space-y-3">
        {items.map((i) => {
          const sev = i.ai_classification?.severity || "low";
          const sevStatus = sev === "high" ? "red" : sev === "medium" ? "amber" : "green";
          return (
            <Link key={i.id} to={`/incidents/${i.id}`} className="block" data-testid={`incident-row-${i.id}`}>
              <Card className="p-5 border-border hover:shadow-md transition-shadow flex items-start gap-4">
                <div className="flex-1 min-w-0">
                  <div className="text-xs font-mono-ui text-muted-foreground">{i.id} · {fmt(i.raised_at)}</div>
                  <div className="text-[15px] font-medium truncate mt-1">{i.ai_classification?.summary || i.text.slice(0, 120)}</div>
                  <div className="text-xs text-muted-foreground mt-1">
                    {i.ai_classification?.category} · escalation: {(i.ai_classification?.escalation_route || []).join(" · ")}
                  </div>
                </div>
                <div className="flex flex-col items-end gap-1">
                  <StatusBadge status={sevStatus} label={sev} />
                  <span className="text-[11px] text-muted-foreground font-mono-ui">{i.status.toUpperCase()}</span>
                </div>
              </Card>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
